/** Attach a drop handler to an element. */
export Drop := (element: Node, handler: (e: Event) =>) =>
  cancel := (e: Event) =>
    e.preventDefault()
    return false

  element.addEventListener "dragover", cancel
  element.addEventListener "dragenter", cancel
  element.addEventListener "drop", (e) =>
    handler(e)

  return () =>
    element.removeEventListener "dragover", cancel
    element.removeEventListener "dragenter", cancel
    element.removeEventListener "drop", handler

export default Drop
